import React, { useState, useCallback, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { IoIosArrowDropdownCircle } from 'react-icons/io';

import { warningLogManager } from 'redux/action/warningLog';

import useCancellationToken from 'utils/customHook/useCancellationToken';
import { moduleScnMap } from 'utils/code';
import { nvlDateTypeReturnToString } from 'utils/nvl';
import { statusMap } from 'utils/code';
import { customAxiosPostFunction } from 'utils/axiosFunction';

import Popup from 'popup/Popup';
import MainLogPopup from '../../MainLogPopup';

import { ModuleBox, ModuleStatusImage } from './SideEventLogs.css.js';

const SideEventLog = ( props ) => {
  const history = useHistory();
  const cancellationToken = useCancellationToken();
  const dispatch = useDispatch();
  const [ graphComponent, setGraphComponent ] = useState('');
  const [ popupOpen, setPopupOpen ] = useState(false);

  useEffect(() => () => cancellationToken.cancel(), []);

  const confirmLog = useCallback(async (warningLogIdx) => {
    await customAxiosPostFunction(history, '/api/log/confirmWarning', {
      warningLogIdx: warningLogIdx
    });

    dispatch(warningLogManager( props.authIdx));
  });
  
  const openPopup = useCallback((data) => {
    setGraphComponent(
      <div style={{background: `#272F3C`, borderRadius: `10px`, padding: `10px`}}>
        <div style={{display: `flex`, justifyContent: `center`, alignItems: `center`, fontSize: `35px`, color: 'white'}}>
          {statusMap[data.status]} / {(data.moduleIdx === 118 || data.moduleIdx === 119 || data.moduleIdx === 120) ? '누액' : moduleScnMap[data.moduleScn + ''].title} / {data.modelNm} / {nvlDateTypeReturnToString(data.rgstDt)}
        </div>
        <MainLogPopup title={moduleScnMap[data.moduleScn + ''].title}
                      engTitle={moduleScnMap[data.moduleScn + ''].engTitle}
                      logIdx={data.logIdx}
                      moduleIdx={data.moduleIdx}
                      moduleScn={data.moduleScn} />
      </div>
    )
    setPopupOpen(true);
  }, [props]);

  return (
    <>
      <ModuleBox status={props.status} >
        <ModuleStatusImage status={props.status} onClick={() => {openPopup(props)}} />
        <div className="systemLogContent" onClick={() => openPopup(props)}>
          {props.modelNm} ({props.areaNm})
          <br/>
          {nvlDateTypeReturnToString(props.rgstDt)}
        </div>
        <div className="confirmBtn" onClick={() => confirmLog([props.warningLogIdx])}>
          <IoIosArrowDropdownCircle />
        </div>
      </ModuleBox>

      <Popup
        modal
        closeOnDocumentClick
        open={popupOpen}
        onClose={() => {setPopupOpen(false);}}
        >
        {graphComponent}
      </Popup>
    </>
  )
}

export default SideEventLog;